import { urls } from '../../../urls';

export const fetchToken = async (user: any, jwtToken: string): Promise<Response> => {
    const authUrl = urls.AUTH;
    const tokenHandler = (process.env.REACT_APP_USE_MULTI_TOKEN_HANDLER === 'true') ? 'multi-token-handler' : 'token-handler';
    const access_token = jwtToken
    const refresh_token = user.signInUserSession.refreshToken.token
    const body = {
        action: 'SECURE_TOKEN',
        access_token,
        refresh_token
    }
    const resp = await fetch(`${authUrl}/auth/${tokenHandler}`, {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: "include"
    })

    return resp;


}